import classNames from 'classnames'
import { useTranslation } from 'next-i18next'
import React from 'react'

import styles from './somethingWentWrong.module.scss'

import type { SomethingWentWrongProps } from './something-went-wrong.types'

function SomethingWentWrongLegacy({ show = true, minHeight, wrapperClass }: SomethingWentWrongProps) {
  const { t } = useTranslation('accountPage')
  if (!show) return null

  return (
    <div className={classNames(styles.graceful_error_message_wrapper, wrapperClass)} style={{ minHeight }}>
      <div className={styles.graceful_error_message_content}>
        {t('somethingWentWrong')}
        <br />
        {t('refreshPage')}
      </div>
    </div>
  )
}

export default SomethingWentWrongLegacy
